export default {
    CompleteCustomerRegister: {
        title: 'Complete seu cadastro!',
        text: 'Você ainda não completou seu cadastro.'
    }
}